import { dispatch } from "../store/store";
import {
  getScheduleEventsData,
  getScheduleEventsByPharmaciesData,
  setIsEventsLoading,
  setIsEventCalendarLoading,
  getResourcesData,
  getAllPharmacistsData,
  addScheduleEventData,
  deleteScheduleEventsData,
  addBlockOutData,
  deleteBlockOutData,
  updateBlockOutData,
  setScheduleEventsList,
  setMyAppointmentList,
  getUsrAvailibilityData,
  getUsersAvailabilityByPriorityData,
  setShowBookingSlotsData,
  setBookingSlotsModeData,
  setShowBacktoSlotsButtonData,
  getMyAppointmentsData,
  setMyAppointments,
  saveGoogleEventsData,
  getGoogleEventsData,
  getAllUserWeekAvailabilityData,
  addAndUpdateTaskEventData,
  saveUserSettingsData,
  setIsSavingUserSettings,
  getUserDefaultCalendarViewData,
  setUserDefaultCalendarView,
  setGoogleCalendarStatus,
  setIsGoogleCalendarSyncing,
  setGoogleCalendarsList,
  setIsConsultationRouteData,
  getGoogleOAuthUrlData,
  getGoogleCalendarStatusData,
  getGoogleCalendarsData,
  triggerGoogleCalendarSyncData,
  syncAppointmentToGoogleData,
  deleteAppointmentFromGoogleData,
  disconnectGoogleCalendarData,
} from "../features/scheduleEventsSlice/scheduleEventsSlice";
import { logErrorWithPayload } from "../services/logService";
import { httpGet, httpPost } from "../services/httpService";
import {
  getScheduleEventsUrl,
  addBlockOutUrl,
  getScheduleEventsByCompanyUrl,
} from "../apiUrls/apiUrls";

const reducerName = "scheduleEvents";

// #region State Setters
export const setEventsLoading = (isLoading) => {
  dispatch(setIsEventsLoading(isLoading));
};
export const setShowBookingSlots = (isLoading) => {
  dispatch(setShowBookingSlotsData(isLoading));
};
export const setBookingSlotsMode = (mode) => {
  dispatch(setBookingSlotsModeData(mode));
};
export const setShowBacktoSlotsButton = (mode) => {
  dispatch(setShowBacktoSlotsButtonData(mode));
};
export const setGoogleCalendarStatusData = (status) => {
  dispatch(setGoogleCalendarStatus(status));
};
export const setIsGoogleCalendarSyncingData = (isSyncing) => {
  dispatch(setIsGoogleCalendarSyncing(isSyncing));
};
export const setGoogleCalendarsListData = (list) => {
  dispatch(setGoogleCalendarsList(list));
};
export const setIsConsultationRoute = (isConsultationRoute) => {
  dispatch(setIsConsultationRouteData(isConsultationRoute));
}
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getScheduleEvents = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(getScheduleEventsData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);

    logErrorWithPayload(error, pharmacyId);
    result = null;
  }
  return result;
};
export const getResources = async (companyID, pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(
      getResourcesData({ companyID, pharmacyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }
  return result;
};
export const getAllPharmacists = async (companyID, pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(
      getAllPharmacistsData({ companyID, pharmacyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }
  return result;
};

export const getScheduleEventsByPharmacies = async (
  pharmacyIds,
  { silent = false } = {},
) => {
  let result = null;
  try {
    result = await dispatch(
      getScheduleEventsByPharmaciesData(
        silent ? { pharmacyIds, silent } : pharmacyIds,
      ),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyIds);
    result = null;
  }
  return result;
};

export const addBlockOut = async (data, pharmacyId) => {
  let result = null;

  try {
    result = await dispatch(addBlockOutData({ data, pharmacyId })).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }

  return result;
};

export const deleteScheduleEvents = async (eventID, currentPharmacyId) => {
  let result = null;

  try {
    result = await dispatch(
      deleteScheduleEventsData({ eventID, currentPharmacyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, eventID);
    result = null;
  }

  return result;
};

export const addScheduleEvent = async (data, pharmacyId) => {
  let result = null;

  try {
    result = await dispatch(
      addScheduleEventData({ data, pharmacyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }

  return result;
};

export const updateBlockOut = async (data, pharmacyId) => {
  let result = null;

  try {
    result = await dispatch(updateBlockOutData({ data, pharmacyId })).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }

  return result;
};

export const deleteBlockOut = async (eventID, currentPharmacyId) => {
  let result = null;

  try {
    result = await dispatch(
      deleteBlockOutData({ eventID, currentPharmacyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, eventID);
    result = null;
  }

  return result;
};

export const refreshScheduleEventsSilently = async (pharmacyId) => {
  try {
    const url = getScheduleEventsUrl(pharmacyId);
    const events = await httpGet(url);
    dispatch(setScheduleEventsList(events));
    return events;
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    return null;
  }
};

export const addBlockOutAndRefresh = async (payload, pharmacyId) => {
  // Maintain loading state through both API calls
  dispatch(setIsEventCalendarLoading(true));
  try {
    // Make the add block out API call directly to avoid thunk managing loading state
    const addUrl = addBlockOutUrl(pharmacyId);
    await httpPost(addUrl, payload);

    // Refresh data to sync with server
    const getUrl = getScheduleEventsUrl(pharmacyId);
    const events = await httpGet(getUrl);
    dispatch(setScheduleEventsList(events));
    return events;
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    throw error;
  } finally {
    // Clear loading state only after both operations complete
    dispatch(setIsEventCalendarLoading(false));
  }
};

export const getUsrAvailibility = async (userEmail, serviceID, pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(
      getUsrAvailibilityData({ userEmail, serviceID, pharmacyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, serviceID);
    result = null;
  }
  return result;
};

export const getUsersAvailabilityByPriority = async (
  companyID,
  serviceID,
  pharmacyID,
) => {
  let result = null;
  try {
    result = await dispatch(
      getUsersAvailabilityByPriorityData({ companyID, serviceID, pharmacyID }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, serviceID);
    result = null;
  }
  return result;
};

export const getMyAppointments = async () => {
  let result = null;
  try {
    result = await dispatch(getMyAppointmentsData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error, "getMyAppointments");
    result = null;
  }
  return result;
};

export const refreshMyAppointmentsSilently = async () => {
  try {
    const url = getScheduleEventsByCompanyUrl();
    const events = await httpGet(url);
    dispatch(setMyAppointmentList(events));
    return events;
  } catch (error) {
    return null;
  }
};

export const saveGoogleEvents = async (mappedEvents) => {
  let result = null;
  try {
    result = await dispatch(saveGoogleEventsData(mappedEvents)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, "saveGoogleEvents");
    result = null;
  }
  return result;
};

export const getGoogleEvents = async (companyID, pharmacyID) => {
  let result = null;
  try {
    result = await dispatch(
      getGoogleEventsData({ companyID, pharmacyID }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, "getGoogleEvents");
    result = null;
  }
  return result;
};

export const getAllUserWeekAvailability = async () => {
  let result = null;
  try {
    result = await dispatch(getAllUserWeekAvailabilityData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error, "getAllUserWeekAvailability");
    result = null;
  }
  return result;
};

export const addAndUpdateTaskEvent = async (data, pharmacyId) => {
  let result = null;

  try {
    result = await dispatch(
      addAndUpdateTaskEventData({ data, pharmacyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }

  return result;
};

export const saveUserSettings = async (payload) => {
  let result = null;
  try {
    result = await dispatch(saveUserSettingsData(payload)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, payload);
    result = null;
  }
  return result;
};

export const getUserDefaultCalendarView = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(getUserDefaultCalendarViewData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = null;
  }
  return result;
};

export const setUserDefaultCalendarViewData = (data) => {
  dispatch(setUserDefaultCalendarView(data));
};

// #region Google Calendar Dispatchers
export const getGoogleOAuthUrl = async (pharmacyId = null, companyId = null) => {
  let result = null;
  try {
    result = await dispatch(
      getGoogleOAuthUrlData({ pharmacyId, companyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, "getGoogleOAuthUrl");
    result = null;
  }
  return result;
};

export const getGoogleCalendarStatus = async () => {
  let result = null;
  try {
    result = await dispatch(getGoogleCalendarStatusData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error, "getGoogleCalendarStatus");
    result = null;
  }
  return result;
};

export const getGoogleCalendars = async () => {
  let result = null;
  try {
    result = await dispatch(getGoogleCalendarsData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error, "getGoogleCalendars");
    result = null;
  }
  return result;
};

export const triggerGoogleCalendarSync = async (
  fullSync = false,
  pharmacyId = null,
  syncGoogleToTitanverse = true,
  companyId = null,
) => {
  let result = null;
  try {
    result = await dispatch(
      triggerGoogleCalendarSyncData({
        fullSync,
        pharmacyId,
        syncGoogleToTitanverse,
        companyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(
      error,
      `triggerGoogleCalendarSync fullSync=${fullSync} pharmacyId=${pharmacyId} syncGoogleToTitanverse=${syncGoogleToTitanverse} companyId=${companyId}`,
    );
    result = null;
  }
  return result;
};

export const syncSingleAppointmentToGoogle = async (appointmentId) => {
  let result = null;
  try {
    result = await dispatch(
      syncAppointmentToGoogleData(appointmentId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(
      error,
      `syncSingleAppointmentToGoogle appointmentId=${appointmentId}`,
    );
    result = null;
  }
  return result;
};

export const deleteSingleAppointmentFromGoogle = async (appointmentId) => {
  let result = null;
  try {
    result = await dispatch(
      deleteAppointmentFromGoogleData(appointmentId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(
      error,
      `deleteSingleAppointmentFromGoogle appointmentId=${appointmentId}`,
    );
    result = null;
  }
  return result;
};

export const disconnectGoogleCalendar = async () => {
  let result = null;
  try {
    result = await dispatch(disconnectGoogleCalendarData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error, "disconnectGoogleCalendar");
    result = null;
  }
  return result;
};
// #endregion

// #endregion
